var map = {
	"./accessories.svg": "ccdb",
	"./approach.svg": "530c",
	"./arrow_down.svg": "271a",
	"./autorenew.svg": "71c4",
	"./b2b_frame.svg": "fe97",
	"./blinds.svg": "1af8",
	"./briefcase.svg": "19b6",
	"./calendar.svg": "76b2",
	"./calendarBenefit.svg": "c2ad",
	"./car.svg": "a7d8",
	"./career.svg": "8925",
	"./cargoTruck.svg": "2ae4",
	"./cart.svg": "c0c3",
	"./certificate.svg": "9942",
	"./chart.svg": "3653",
	"./close.svg": "bb7c",
	"./closepopup.svg": "223b",
	"./colour_palette.svg": "be66",
	"./cookie.svg": "5e15",
	"./delivery.svg": "d373",
	"./design.svg": "ee14",
	"./design_palette.svg": "9e00",
	"./deweloper.svg": "8965",
	"./discount.svg": "064c",
	"./doors.svg": "a8de",
	"./doors_aluminum.svg": "dca7",
	"./download.svg": "8215",
	"./durable.svg": "ff38",
	"./easy.svg": "26ec",
	"./eco.svg": "bf63",
	"./email.svg": "da8d",
	"./envelope.svg": "c22f",
	"./environment.svg": "c555",
	"./exclusive.svg": "62c0e",
	"./facebook.svg": "7e4b",
	"./factory.svg": "64a5",
	"./finger.svg": "4212",
	"./forbes_white2.svg": "7bb7",
	"./frame.svg": "d894",
	"./garage.svg": "2812",
	"./germany.svg": "0d1c",
	"./growth.svg": "e7da",
	"./handshake.svg": "d9c9",
	"./handshake2.svg": "3db4",
	"./handshake_job.svg": "f015",
	"./highlighted.svg": "651d",
	"./history.svg": "69ff",
	"./home.svg": "f2a5",
	"./info.svg": "69d9",
	"./knowledge.svg": "3650",
	"./label.svg": "5866",
	"./light.svg": "bf22",
	"./lightbulb.svg": "104b",
	"./like.svg": "8909",
	"./linkedin.svg": "b2c5",
	"./logo_color.svg": "59d5",
	"./mail.svg": "4f1b",
	"./man.svg": "b947",
	"./money.svg": "4f35",
	"./montage.svg": "1c25",
	"./net.svg": "34c9",
	"./new.svg": "fefd",
	"./opinions.svg": "6121",
	"./order_list.svg": "7f33",
	"./other_cart.svg": "a457",
	"./package.svg": "3349",
	"./paperology.svg": "e5b1",
	"./people.svg": "6c77",
	"./phone.svg": "1f9a",
	"./phoneCall.svg": "a5a2",
	"./pin.svg": "a03c",
	"./pinterest.svg": "8852",
	"./premium.svg": "a1ce",
	"./presentation.svg": "e0d5",
	"./priceTag.svg": "ca5a",
	"./private.svg": "7b07",
	"./product_stack.svg": "8c5c",
	"./public.svg": "09a8",
	"./question.svg": "22e2",
	"./quote.svg": "deae",
	"./regulamins.svg": "1257",
	"./rollers.svg": "de37",
	"./safety.svg": "e03f",
	"./scroll_down.svg": "5ba0c",
	"./scroll_down_b2b.svg": "d988",
	"./send.svg": "f95f",
	"./sills.svg": "bbda",
	"./slider_frame.svg": "42c4",
	"./smile.svg": "cd22",
	"./stack.svg": "b7fb5",
	"./standard.svg": "5366",
	"./star.svg": "ec6f",
	"./status.svg": "7a62",
	"./team.svg": "58d0",
	"./technology.svg": "dc56",
	"./temperature.svg": "f4c8",
	"./terrace.svg": "9102",
	"./training.svg": "c852",
	"./warranty.svg": "713d",
	"./water_drop.svg": "fa6a",
	"./windows.svg": "2e80",
	"./windows_aluminum.svg": "abda",
	"./woman.svg": "0fca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e0f8";